import { render, staticRenderFns } from "./EditActivationCopyButton.vue?vue&type=template&id=2c3b557c&scoped=true"
import script from "./EditActivationCopyButton.vue?vue&type=script&lang=ts"
export * from "./EditActivationCopyButton.vue?vue&type=script&lang=ts"
import style0 from "./EditActivationCopyButton.vue?vue&type=style&index=0&id=2c3b557c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b557c",
  null
  
)

export default component.exports